module.exports = __webpack_public_path__ + "static/media/logo-unid-blanco.6a9678e0.png";